import { ChangeDetectorRef, Component, EventEmitter, inject, input, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TextareaModule } from 'primeng/textarea';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Service } from '../../models/service';
import { HttpErrorResponse } from '@angular/common/http';
import { UiNotificationService } from '../../services/ui-notification.service';
import { ApiService } from '../../services/api.service';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-service-dialog',
  imports: [
    FormsModule,
    DialogModule,
    InputTextModule,
    DividerModule,
    SelectButtonModule,
    InputNumberModule,
    TextareaModule,
    ToggleSwitchModule,
    ButtonModule,
    TranslatePipe
  ],
  templateUrl: './service-dialog.component.html',
  styles: ``,
})
export class ServiceDialogComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private langSubscription!: Subscription

 @Input() messageService!: UiNotificationService;

  // visibilità dialog (bidirezionale)
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() service: Service = Reset.service();

  // evento finale
  @Output() saved = new EventEmitter<Service>();

  useLimit: boolean = true;
  modeOptions: any[] = [];

  constructor(private apiService: ApiService, private cdr: ChangeDetectorRef) {
  }

  ngOnChanges() {
    this.useLimit = this.service.limit > 0;
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.langSubscription) {
      this.langSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.langSubscription = this.translate.stream(['months', 'executions']).subscribe(translations => {
      this.modeOptions = [
        { label: translations['executions'], value: true },
        { label: translations['months'], value: false }
      ];
    });
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onModeSelection(): void {
    this.useLimit = !this.useLimit;

    if (this.useLimit) {
      this.service.expirationMonths = 1;
    } else {
      this.service.limit = 0;
    }
  }

  onSave(): void {
    this.apiService.updateService(this.service).subscribe({
      next: () => {
        this.savedCompleted();
        this.messageService.showSuccess('messages.dataSaved');
      },
      error: (err: HttpErrorResponse) => {
        this.messageService.showError(err);
      }
    });
  }

  private savedCompleted() {
    this.saved.emit(this.service);
    this.onClose();
  }
}
